module.exports = __webpack_public_path__ + "img/3w.2ba0790d.svg";